import * as types from '../types'

/**
 * 通用数据
 * loading:     是否加载
 * direction:   页面切换方向
 * tabButtons:  底部菜单
 * curTab:      当前选中的底部菜单
 * features:    用户功能列表
 * discover:    优惠导航
 * needBind:    需要绑定
 * bindParam:   绑定参数
 * token:       用户token
 * showBorttom: 展示底部菜单
 * scrollTop:   滚动距离
 * serverTime:  服务器时间
 * @type {Object}
 */
const state = {
    needBind: false,
    bindParam: {
        phone: '',
        captcha: '',
        code: '',
    },
    token: localStorage.getItem("RS-TOKEN"),
    loading: true,
    direction: 'forward',
    tabButtons: [
        {
            name: '首页',
            icon: 'icon-shouye',
            url: '/'
        },
        // {
        //     name: '客服',
        //     icon: 'icon-kefu',
        //     url: 'https://cdn.yw0511.com/html/custom-service.html'
        // },
        {
            name: '优惠',
            icon: 'icon-youhui',
            url: '/discover'
        },
        {
            name: '购物车',
            icon: 'icon-gouwuche',
            url: '/cart'
        },
        {
            name: '我的',
            icon: 'icon-mine',
            url: '/mine'
        }
    ],
    curTab: 0,
    features: [
        {
            title: '我的订单',
            url: '/order/0',
            thumbnail: 'feature/my-order.png'
        },
        {
            title: '待付款',
            url: '/order/1',
            thumbnail: 'feature/to-pay.png'
        },
        {
            title: '待收货',
            url: '/order/4',
            thumbnail: 'feature/to-receive.png'
        },
        {
            title: '待评价',
            url: '/order/5',
            thumbnail: 'feature/to-comment.png'
        },
        {
            title: '我的套餐',
            url: '/my_package/1',
            thumbnail: 'feature/usually.png'
        },
        {
            title: '我喜欢的',
            url: '/my_favor/1',
            thumbnail: 'feature/my-favor.png'
        },
        {
            title: '我评论的',
            url: '',
            thumbnail: 'feature/my-comment.png'
        },
        {
            title: '充值卡充值',
            url: '/balance/1',
            thumbnail: 'feature/deposit-card.png'
        }
    ],
    discover: [
        {
            id: 2,
            name: '优惠券'
        },
        {
            id: 3,
            name: '充值专区'
        },
        {
            id: 5,
            name: '优惠'
        },
        {
            id: 6,
            name: '预售'
        }
    ],
    showBottom: false,
    scrollTop: 0,
    serverTime: 0,
    alertTitle: '',
    alertStatus: false,
    confirmStatus: false,
    website: '原味生活',
    website_thumb: 'https://img.yw0511.com/icon-single-0x01.jpg'
}

const mutations = {
    [types.BIND_USER](state) {
        state.needBind = true
    },

    [types.UPDATE_LOADING](state, status) {
        state.loading = status
    },

    [types.UPDATE_DIRECTION](state, direction) {
        state.direction = direction
    },

    [types.CHANGE_CUR_TAB](state, curTab) {
        state.curTab = curTab
    },

    [types.CHANGE_LOGIN_INFO](state, token) {
        state.token = token
    },

    [types.CHANGE_BOTTOM_STATUS](state, status) {
        state.showBottom = status
    },

    [types.UPDATE_POSITION](state, position) {
        state.scrollTop = position
    },

    [types.UPDATE_SERVER_TIME](state, time) {
        state.serverTime = time
    },

    [types.CHANGE_ALERT_TITLE](state, params) {
        state.alertTitle = params.title,
            state.alertStatus = params.status
    },

    [types.UPDATE_CONFIRM_CONTENT](state, params) {
        state.confirmStatus = params.status
    }
}

const getters = {

}

const actions = {

}

export default {
    state,
    mutations,
    getters,
    actions
}



// WEBPACK FOOTER //
// ./src/vuex/modules/common.js